<template>
  <div class="btn-wrapper" :class="{ 'btn-center': footerDataLen === 1 }">
    <div v-for="(item) in footerData" :key="item.name" v-show="item.check">
      <div
        :class="[
          'btn',
          {
            guide: item.name === 'navigation',
            appointment: item.name === 'appointment',
            clockin: item.name === 'clockIn',
            artifact: item.name === 'relationCate',
            'wandering-hall': item.name === 'exhibition' || footerDataLen === 1,
            locationSignIn: item.name === 'locationSignIn',
          }
        ]"
        :style="getStyle(item.name, item)"
        @click="handleGuide(item.name, item)"
        v-if="item.check && item.name !== 'like'"
      >
        <WxButton
          v-if="item.type === 'APPLETS' && (item.name === 'appointment' || item.name === 'exhibition')"
          :to-mp="true"
          :path="item.pageRoute"
          :username="item.appletsId"
        />
        {{ item.text }}
      </div>
      <!-- 点赞 -->
      <div v-if="activityInfo.mapStyle.fnModule.like && activityInfo.mapStyle.fnModule.like.check && item.check && item.name === 'like'" class="btn like">
        <div :class="['like-btn', { 'has-like': hasLike }]" @click="handleLike">
          <img class="like-icon untouch" :src="require('../../../../assets/images/icon_like_untouch.png')"/>
          <img class="like-icon touch" :src="require('../../../../assets/images/icon_like_btn.png')"/>
        </div>
        <div class="tips">
          <div class="like-num" v-if="activityInfo.mapStyle.fnModule.like && activityInfo.mapStyle.fnModule.like.show">{{ likeNum }}</div>
          <div :class="['plus', {'fade-in-out': !!plus}]">+1</div>
        </div>
        {{ item.text }}
      </div>
    </div>
    <portal to="nf-dialog">
      <NfDialog :isShow.sync="isShow" :info="mainInfo" :type="type" />
    </portal>
    <!-- 签到弹窗 -->
    <sign-in-popup :text="signInInfo.text" :icon="signInInfo.icon" :close="closePopup" :type="popType">
    </sign-in-popup>
  </div>
</template>

<script>
import { jumpToAmap } from '@/utils/amap'
import NfDialog from '../NfDialog/nfDialog.vue'
import WxButton from '@/components/WxButton'
import { mapGetters, mapMutations } from 'vuex'
import openApp from '../../../../utils/openApp'
import { signIn, getLikeNum, like, getHasLike } from '@/server/interfaces'
/* 签到弹窗 */
import SignInPopup from '../SignInPopup'

export default {
  components: { NfDialog, WxButton, SignInPopup },
  name: 'Footer',
  props: {
    footer: {
      type: Object,
      default: null
    },
    mainInfo: {
      type: Object
    },
    handleCheckBoxClicked: {
      type: Function,
      default: ()=>{}
    },
  },
  data () {
    return {
      isShow: false,
      type: null,
      popType: '',
      signInInfo: {},
      map: null,
      likeNum: 0,
      plus: false,
      hasLike: false
    }
  },
  computed: {
    ...mapGetters(['systemInfo']),
    ...mapGetters('activityInfo', ['activityId', 'activityInfo']),
    ...mapGetters('userInfo', ['userInfo']),
    footerData () {
      // 调整云游展馆顺序在最后
      const result = []
      let hasExhibition = false
      Object.keys(this.footer).forEach(item => {
        if (item === 'exhibition') {
          hasExhibition = true
        } else if (this.footer[item].check === true) {
          result.push({
            name: item,
            text: item === 'like' ? '点赞' : '',
            ...this.footer[item]
          })
        }
      })
      hasExhibition && result.push({
        name: 'exhibition',
        ...this.footer.exhibition
      })
      return result
    },
    footerDataLen () {
      return this.footerData.length
    }
  },
  watch: {
    mainInfo(data) {
      if (data.id) {
        this.updateLike()
        this.updateHasLike()
      }
    }
  },
  mounted () {
    this.updateLike()
    this.updateHasLike()
    // 点赞动画
    const btns = Array.from(document.querySelectorAll('.like-icon'))
    const touch = document.querySelector('.touch');
    touch.addEventListener('animationend', () => {
      touch.style.opacity = 1;
      btns.forEach(i => i.classList.remove('animate'));
    })

    const plus = document.querySelector('.plus')
    plus && plus.addEventListener('animationend', () => {
      this.plus = false
      this.updateHasLike()
    })
  },
  methods: {
    ...mapMutations({
      toast: 'toast/showToast',
      setIsShowArtifactList: 'home/setIsShowArtifactList',
      showLoading: "loading/showLoading",
      hideLoading: "loading/hideLoading"
    }),
    updateLike() {
      const { like } = this.activityInfo.mapStyle.fnModule
      if (!(like && like.show)) return
      getLikeNum({ storeId: this.mainInfo.id }).then(res => {
        if (res.code === 200) {
          this.likeNum = res.data
        } else {
          this.toast(res.msg)
        }
      })
    },
    async updateHasLike() {
      if (this.systemInfo.isWx || this.systemInfo.isNfPlus) {
        if (!this.userInfo.userUuid) {
          await this.$store.dispatch('userInfo/getUserInfo')
        }
        if (!this.userInfo.userUuid && this.systemInfo.isNfPlus) {
          await this.$store.dispatch('userInfo/getNfplusUserByLogin')
        }
        const res = await getHasLike({ storeId: this.mainInfo.id })
        if (res.code === 200) {
          this.hasLike = res.data
        } else {
          this.toast(res.msg)
        }
      }
    },
    closePopup() {
      this.popType = ''
    },
    getStyle(key, item) {
      if (key === 'locationSignIn') {
        const customUrl = item.setting.signInWord.button.url
        const defalutIcon = require('@/assets/images/icon_location.png')
        return {
          'background-image': customUrl ?  `url(${customUrl})` : `url(${defalutIcon})`,
        }
      }
    },
    handleGuide (type, info) {
      this.type = type
      type === 'appointment' && this.handleAppointMent(type, info)
      type === 'clockIn' && this.handleClockIn(type, info)
      type === 'exhibition' && this.handleExhibition(type, info)
      type === 'navigation' && this.handleNavigation(type, info)
      type === 'relationCate' && this.handleRelationCate(type, info)
      type === 'locationSignIn' && this.handleLocationSignIn(type, info)
    },
    handleAppointMent (type, info) {
      this.handleCheckBoxClicked({ action: 20, activityId: this.activityId, optionId: this.mainInfo.id, itemType: 2 }) //预约
      if (info.type === 'POPUP') {
        this.isShow = true
      } else if (info.type === 'lINK') {
        if (!info.link) {
          return
        }
        window.open(info.link)
      } else {
        // TODO 小程序跳转逻辑
      }
    },
    async handleLocationSignIn(type, info) {
      this.handleCheckBoxClicked({ action: 23, activityId: this.activityId, optionId: this.mainInfo.id, itemType: 2 })
      if (this.systemInfo.isWx || this.systemInfo.isNfPlus) {
        if (!this.userInfo.userUuid) {
          await this.$store.dispatch('userInfo/getUserInfo')
        }
        if (!this.userInfo.userUuid && this.systemInfo.isNfPlus) {
          await this.$store.dispatch('userInfo/getNfplusUserByLogin')
        }
        const { failSignIn, successSignIn, guideSignIn } = info.setting.signInWord
        this.showLoading("定位签到中...")
        const location = await this.getUserPosition()
        console.log('定位位置', location)
        if (!location) {
          this.hideLoading()
          this.popType = 'guide'
          this.signInInfo.text = guideSignIn.word
          this.signInInfo.icon = guideSignIn.image.url
          return
        }
        let res = null
        try {
          res = await signIn({
            storeId: this.mainInfo.id,
            point: location
          })
        } catch(e) {
          res = { code: 500 }
        }
        this.hideLoading()
        if (res.code === 200) {
          this.popType = 'success'
          this.signInInfo.text = successSignIn.word
          this.signInInfo.icon = successSignIn.image.url
        } else {
          this.popType = 'fail'
          this.signInInfo.text = failSignIn.word
          this.signInInfo.icon = failSignIn.image.url
        }
      } else {
        this.openNfApp()
      }
    },
    async handleClockIn (type, info) {
      this.handleCheckBoxClicked({ action: 22, activityId: this.activityId, optionId: this.mainInfo.id, itemType: 2 })
      if (this.systemInfo.isWx || this.systemInfo.isNfPlus) {
        if (!this.userInfo.userUuid) {
          await this.$store.dispatch('userInfo/getUserInfo')
        }
        if (!this.userInfo.userUuid && this.systemInfo.isNfPlus) {
          await this.$store.dispatch('userInfo/getNfplusUserByLogin')
        }
        this.$router.push({
          path: '/clockIn/site',
          query: { id: this.activityId, shopId: this.mainInfo.id }
        })
      } else {
        this.openNfApp()
      }
    },
    openNfApp() {
      openApp({
        address:
          window.location.origin +
          window.location.pathname +
          this.$router.resolve({
            path: '/',
            query: { id: this.activityId }
          }).href
      }, this.activityId, 39)
    },
    getUserPosition() {
      /* global AMap */
      return new Promise(r => {
        this.map = new AMap.Map('map-container-fake', {
          center: [113.325, 23.137],
        })
        this.map.plugin('AMap.Geolocation', () => {
          const geolocation = new AMap.Geolocation({
            enableHighAccuracy: true, // 是否使用高精度定位，默认:true
            timeout: 10000, // 超过10秒后停止定位，默认：无穷大
            maximumAge: 0, // 定位结果缓存0毫秒，默认：0
            convert: true, // 自动偏移坐标，偏移后的坐标为高德坐标，默认：true
            showButton: false, // 显示定位按钮，默认：true
            showMarker: true, // 定位成功后在定位到的位置显示点标记，默认：true
            showCircle: true, // 定位成功后用圆圈表示定位精度范围，默认：true
            panToLocation: true, // 定位成功后将定位到的位置作为地图中心点，默认：true
            zoomToAccuracy: true, // 定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
          })
          this.map.addControl(geolocation)
          geolocation.getCurrentPosition()
          AMap.event.addListener(geolocation, "complete", obj => {
            r({
              x: obj.position.lng,
              y: obj.position.lat
            })
          }) // 返回定位信息
          AMap.event.addListener(geolocation, "error", () => {
            r(null)
          }) // 返回定位出错信息
        })
      })
    },
    // 云游展馆逻辑
    handleExhibition (type, info) {
      this.handleCheckBoxClicked({ action: 24, activityId: this.activityId, optionId: this.mainInfo.id, itemType: 2 })
      if (info.type === 'POPUP') {
        this.isShow = true
      } else if (info.type === 'lINK') {
        if (!info.link) {
          return
        }
        window.open(info.link)
      } else {
        // TODO 小程序跳转逻辑
      }
    },
    handleNavigation (type, info) {
      this.handleCheckBoxClicked({ action: 21, activityId: this.activityId, optionId: this.mainInfo.id, itemType: 2 })
      const latitude = this.mainInfo.address.point.x
      const longitude = this.mainInfo.address.point.y
      const address = this.mainInfo.address.address
      jumpToAmap(latitude, longitude, address) // 这里现在是写死的
    },
    handleRelationCate (type, info) {
      this.setIsShowArtifactList(true)
    },
    likeAnimate() {
      const btns = Array.from(document.querySelectorAll('.like-icon'))
      btns.forEach(i => i.classList.add('animate'));
    },
    async handleLike () {
      if (this.systemInfo.isWx || this.systemInfo.isNfPlus) {
        if (!this.userInfo.userUuid) {
          await this.$store.dispatch('userInfo/getUserInfo')
        }
        if (!this.userInfo.userUuid && this.systemInfo.isNfPlus) {
          await this.$store.dispatch('userInfo/getNfplusUserByLogin')
        }
        // 点赞动画
        this.likeAnimate()
        // 点赞
        const res = await like({
          storeId: this.mainInfo.id,
          origin: this.systemInfo.isNfPlus ? 'APP' : 'SHARE'
        })
        if (res.code === 200) {
          // 有延迟
          this.likeNum += 1
          this.plus = true
        } else {
          this.toast(res.msg)
        }
      } else {
        this.openNfApp()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes fadeInOut {
  0% {
    opacity: 0;
    transform: translateY(0);
  }
  50% {
    opacity: 1;
    transform: translateY(-0.1rem);
  }
  100% {
    opacity: 0;
    transform: translateY(-0.2rem);
  }
}
@keyframes like {
  0% {
    transform: scale(1) rotate(0);
    opacity: 1;
  }
  10% {
    transform: scale(0.5) rotate(10deg);
    opacity: 0.71;
  }
  50% {
    transform: scale(0.1) rotate(20deg);
    opacity: 0.42;
  }
  75% {
    transform: scale(0.5) rotate(10deg);
    opacity: 0.71;
  }
  100% {
    transform: scale(1) rotate(0);
    opacity: 1;
  }
}
.btn-wrapper {
  height: 100%;
  width: 100%;
  background: #fff;
  font-size: 0.26rem;
  color: #666;
  display: flex;
  justify-content: center;
  align-items: center;
  .btn {
    text-align: center;
    position: relative;
    width: 0.8rem;
    height: 0.87rem;
    line-height: 1.4rem;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .locationSignIn {
    width: 1.3rem;
    // overflow: visible !important;
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 0.44rem;
  }
  .guide {
    background: url(../../../../assets/images/icon_navigation.png) no-repeat top center;
    background-size: 0.41rem;
  }
  .like {
    line-height: unset !important;
    overflow: visible;

    .like-btn {
      position: relative;
      width: 0.41rem;
      height: 0.41rem;
      margin-bottom: 5px;
      .like-icon {
        position: absolute;
        width: 0.41rem;
        height: 0.41rem;
      }
      .touch {
        opacity: 0;
      }
      .animate {
        animation-name: like;
        animation-duration: 0.3s;
        animation-timing-function: ease-out;
      }
    }
    .has-like {
      .untouch {
        opacity: 0;
      }
      .touch {
        opacity: 1;
      }
    }
    .tips {
      position: absolute;
      left: 0.5rem;
      bottom: 0.67rem;
    }
    .like-num {
      display: inline-block;
      padding: 0rem 0.16rem;
      background-color: #FF5050;
      border: 2px solid rgba(255,255,255,1);
      border-radius: 0.29rem;
      font-size: 0.2rem;
      font-weight: 500;
      color: #FFFFFF;
    }
    .plus {
      display: inline-block;
      color: #FF5050;
      font-size: 0.2rem;
      font-weight: 500;
      opacity: 0;
    }
    .plus.fade-in-out {
      animation-name: fadeInOut;
      animation-duration: 1s;
    }
  }
  .appointment {
    background: url(../../../../assets/images/icon_book.png) no-repeat top center;
    background-size: 0.41rem;
  }
  .clockin {
    background: url(../../../../assets/images/icon_clock.png) no-repeat top center;
    background-size: 0.41rem;
  }
  .artifact {
    background: url(../../../../assets/images/icon_yz.png) no-repeat top center;
    background-size: 0.41rem;
  }
  .wandering-hall {
    width: 2.23rem;
    height: 0.75rem;
    line-height: 0.75rem;
    background-image: linear-gradient(180deg, #ff601a 0%, #dc0808 100%);
    background-size: 2.23rem 0.75rem;
    border-radius: 0.38rem;
    color: #fff;
    font-size: 0.3rem;
    text-align: center;
    margin-left: 0;
  }
}

.btn-center {
  justify-content: center;
}
</style>
